import {
  SUN, MON, TUE, WED, THU, FRI, SAT
} from '../utils/recurrence';

export const daysInWeek = (locale) => [
  {
    value: 7,
    id: SUN,
    label: locale.get('schedulerReact.sun')
  },
  {
    value: 1,
    id: MON,
    label: locale.get('schedulerReact.mon')
  },
  {
    value: 2,
    id: TUE,
    label: locale.get('schedulerReact.tue')
  },
  {
    value: 3,
    id: WED,
    label: locale.get('schedulerReact.wed')
  },
  {
    value: 4,
    id: THU,
    label: locale.get('schedulerReact.thu')
  },
  {
    value: 5,
    id: FRI,
    label: locale.get('schedulerReact.fri')
  },
  {
    value: 6,
    id: SAT,
    label: locale.get('schedulerReact.sat')
  }
];

export const getWeeklyOptions = (locale, dayOptions) => (
  daysInWeek(locale).filter(day => dayOptions.includes(day.id))
);
